import { removeStopwords } from "stopword"
import { breakpoint } from "../types/constants"

export const acronym = (words:string) => {
    
    const wordArray = words.split(breakpoint)
    const capitalizedWords = wordArray.filter(iscapitalized)
    const acronym = capitalizedWords.map(word => word.charAt(0)).join('').toUpperCase();
    return acronym;

}

// Check if the first character of the word is capitalized
const iscapitalized = (word:string) =>{
    return /^[A-Z]/.test(word);

}